import { createFileRoute } from '@tanstack/react-router';

import { CreatePublishJobPage } from '@/features/publishing/components/create-publish-job-page';
import { requireOrganizationRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/publishing/new')({
    beforeLoad: requireOrganizationRoute,
    component: CreatePublishJobPage
});
